import {Checkbox, Table} from "semantic-ui-react";
import React from "react";

export function ExportInvoicePreview(props) {
    const {data, handleCheck} = props
    const invoices = data.invoices

    const listInvoices = Array.from(invoices.values()).map((invoice) =>
        <Table.Row key={invoice.id}>
            <Table.Cell><Checkbox key={invoice.id} name={invoice.id.toString()} onChange={() => handleCheck(invoice.id)}
                                  checked={invoice.checked}/></Table.Cell>
            <Table.Cell>{invoice.id}</Table.Cell>
            <Table.Cell>{invoice.invoice_number}</Table.Cell>
            <Table.Cell>{invoice.date}</Table.Cell>
            <Table.Cell>{invoice.customer_name}</Table.Cell>
            <Table.Cell>{invoice.exported_to_steuerberater}</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Auswahl</Table.HeaderCell>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>NR</Table.HeaderCell>
                    <Table.HeaderCell>Rechnungsdatum</Table.HeaderCell>
                    <Table.HeaderCell>Kunde</Table.HeaderCell>
                    <Table.HeaderCell>Exportdatum</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listInvoices}</Table.Body>
        </Table>
    )
}